@let isBlocked = blocked();

<ng-template #sideRow let-side="side" let-icon="icon">
    <div class="space-row" [class.custom]="shown()[side] > 0">
        <ra-icon class="space-row-icon" [icon]="icon" varColor="currentColor" [size]="14" />
        <span class="space-row-label">{{ 'document.edit.spacing.' + side | translate }}</span>
        <div class="space-stepper">
            <button
                type="button"
                class="space-step"
                [disabled]="isBlocked || shown()[side] <= 0"
                [attr.aria-label]="('document.edit.spacing.decrease' | translate) + ': ' + ('document.edit.spacing.' + side | translate)"
                (click)="step(side, -1)">
                <ra-icon icon="minus" varColor="currentColor" [size]="14" />
            </button>
            <label class="space-field">
                <input
                    type="text"
                    inputmode="decimal"
                    autocomplete="off"
                    [value]="text(side)"
                    [disabled]="isBlocked"
                    [attr.aria-label]="'document.edit.spacing.' + side | translate"
                    (input)="onInput(side, $event)"
                    (keydown)="onKeydown(side, $event)"
                    (blur)="commit(side)" />
                <span>pt</span>
            </label>
            <button
                type="button"
                class="space-step"
                [disabled]="isBlocked"
                [attr.aria-label]="('document.edit.spacing.increase' | translate) + ': ' + ('document.edit.spacing.' + side | translate)"
                (click)="step(side, 1)">
                <ra-icon icon="add" varColor="currentColor" [size]="14" />
            </button>
        </div>
    </div>
</ng-template>

<div class="chip-wrapper" clickOutside [clickOutsideEnabled]="showMenu()" (clickOutside)="showMenu.set(false)">
    @if (!buttonless()) {
        <ra-square-icon
            backgroundColor="ghost"
            icon="item-spacing"
            [size]="48"
            [iconSize]="22"
            [active]="showMenu()"
            [class.default-disabled]="isBlocked"
            [ariaLabel]="'document.edit.spacing.title' | translate"
            [raEditTooltip]="showMenu() ? null : { text: ('document.edit.spacing.title' | translate), position: 'left' }"
            (click)="!isBlocked && toggleMenu()"
        />
        <!-- Ponto azul: este campo tem espaçamento próprio. -->
        @if (custom() && !showMenu()) {
            <i class="custom-dot" aria-hidden="true"></i>
        }
    }

    @if (showMenu()) {
        <div class="look-menu" raRailMenu (raRailMenuClose)="showMenu.set(false)">
            <p class="look-title">{{ 'document.edit.spacing.title' | translate }}</p>
            <p class="look-subtitle">{{ 'document.edit.spacing.hint' | translate }}</p>

            <!-- Um lado por linha, na ordem de leitura do PDF: acima, abaixo, esquerda, direita. -->
            <div class="space-list">
                <ng-container *ngTemplateOutlet="sideRow; context: { side: 'top', icon: 'arrow-up' }" />
                <ng-container *ngTemplateOutlet="sideRow; context: { side: 'bottom', icon: 'arrow-down' }" />
                <ng-container *ngTemplateOutlet="sideRow; context: { side: 'left', icon: 'arrow-left' }" />
                <ng-container *ngTemplateOutlet="sideRow; context: { side: 'right', icon: 'arrow-right' }" />
            </div>

            @if (custom()) {
                <span class="look-divider"></span>
                <button type="button" class="look-link" [disabled]="isBlocked" (click)="reset()">
                    {{ 'document.edit.spacing.reset' | translate }}
                </button>
            }
        </div>
    }
</div>
